import React from "react";
import { withTranslation } from 'react-i18next';
import {
  WbEventHandlerMixins,
  WbMarkdownHtml,
  registerQuickAddAutoComplete,
  quickAddEventHandler,
  removeEmojiContent,
  getUserId,
  getWsTagId,
  sanitize,
} from "../../utils/common";

import { autoResizeTextArea } from "./commonTags";

// Topic textarea edit
class PostTopicEditText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "topic",
      tag: 0,
      act: "edit"
    };
    this.saveEditedTopic = this.saveEditedTopic.bind(this);
    this.updateTopic = this.updateTopic.bind(this);
    this.submitUpdatedTopic = this.submitUpdatedTopic.bind(this);
    this.afterUpdateTopic = this.afterUpdateTopic.bind(this);
    this.selectArea = this.selectArea.bind(this);
    this.wrapperRef = React.createRef();
    this.handleCloseWindow = this.handleCloseWindow.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.componentCleanUp = this.componentCleanUp.bind(this);
  }

  componentDidMount() {
    const { topic, userPermission, meetingObj } = this.props;
    const eleId = this.getEleId();
    if(typeof eleId != 'undefined' && eleId){
      initializeMeetingEditor(eleId, this.saveEditedTopic);
    }
    if (
      typeof userPermission.execute !== "undefined" &&
      userPermission.execute == "1" &&
      topic.ai_id == null
    ) {
      registerQuickAddAutoComplete(
        `#meeting_topic_${meetingObj.id}_${topic.id}`
      );
    }
    window.addEventListener('beforeunload', this.handleCloseWindow)
    document.addEventListener('mousedown', this.handleClickOutside);
    //window.addEventListener("click", this.saveEditedTopic, true);
    //autoResizeTextArea({ eleId: `#${eleId}` });
    WbEventHandlerMixins.placeCaretAtEnd($(`#${eleId}`).get(0));
  }

  componentCleanUp() {
    window.removeEventListener('beforeunload', this.handleCloseWindow)
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.componentCleanUp();
  }

  handleCloseWindow (e) {
    const { meetingObj, topic } = this.props
    const { id: meetingId } = meetingObj
    const { id: topicId, description } = topic

    const previousTopicText = description

    const eleId = `meeting_topic_${meetingId}_${topicId}`
    const topicCKEditorInputValue = $(`#cke_${eleId} iframe`).contents().find('body').html()
    const newTopicText = $(topicCKEditorInputValue).text().trim()

    if (previousTopicText !== newTopicText) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  handleClickOutside(event) {
    const id = `meeting_topic_${this.props.meetingObj.id}_${this.props.topic.id}`;
    const linkPopup = $(`.cke_editor_${id}_dialog`);
    if ($('#cke_'+id).length > 0 && !event.target.parentElement.classList.contains('subTopicBtn') && this.wrapperRef && !this.wrapperRef.current.contains(event.target) && (linkPopup.length == 0 || (linkPopup.length > 0 && linkPopup.css('display') == 'none'))) {
      this.saveEditedTopic(event);
      this.componentCleanUp();
      if($('.mention-suggestions').length > 0 && $(event.currentTarget.activeElement).parents('.cke').length < 1) {
        $('.mention-suggestions').remove();
        $('.mention-suggestions-div').remove();
      }
    }
  }

  getEleId = () =>{
    return `meeting_topic_${this.props.meetingObj.id}_${this.props.topic.id}`;
  }
  saveEditedTopic(e) {
    const { topic, meetingObj } = this.props;
    const empTopicContainer = $(`#meeting_topic_${meetingObj.id}_${topic.id}`);
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");

    let topicCKEditorInput = $(`#cke_meeting_topic_${meetingObj.id}_${topic.id}`);
    if(topicCKEditorInput != undefined) {
      let topicCKEditorInputValue = $(`#cke_meeting_topic_${meetingObj.id}_${topic.id}` + ' iframe').contents().find('body').html();
      if ($(topicCKEditorInputValue).text() == '') {
        topicCKEditorInputValue= '';
      }
      empTopicContainer.val(topicCKEditorInputValue);
    }


    // adding a more reliable way to track click vs drag (mousedown/mouseup)
    let highlightedText = "";
    if (window.getSelection) {
      highlightedText = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
      highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      if (
        !$(empTopicContainer).is(e.target) &&
        $(empTopicContainer).has(e.target).length === 0 &&
        (!$(agendaSearchContainer).is(e.target) &&
          $(agendaSearchContainer).has(e.target).length === 0) &&
        (!$(tagListContainer).is(e.target) &&
          $(tagListContainer).has(e.target).length === 0)
      ) {
        const topicText = $.trim($(empTopicContainer).val());
        if (
          $(empTopicContainer)
            .val()
            .trim().length == 0
        ) {
          this.afterUpdateTopic('', topic.id)
          setTimeout(() => {
            WbEventHandlerMixins.placeCaretAtEnd(
              $(`#meeting_topic_${meetingObj.id}_${topic.id}`).get(0)
            );
          }, 10);
          return;
        }

        // Remove emojis from the text
        let removeEmoji = removeEmojiContent(topicText);

        if (typeof removeEmoji !== 'undefined' && removeEmoji !== null && removeEmoji) {
          let sanitizedText = sanitize(removeEmoji);
          this.submitUpdatedTopic(sanitizedText);
        }
      } else if (
        $(agendaSearchContainer).is(e.target) ||
        $(agendaSearchContainer).has(e.target).length > 0
      ) {
        setTimeout(() => {
          WbEventHandlerMixins.placeCaretAtEnd(
            $(`#meeting_topic_${meetingObj.id}_${topic.id}`).get(0)
          );
        }, 10);
      }
    }
  }

  updateTopic(e) {
    const { topic, meetingObj } = this.props;
    // Notify typing event
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }
    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }

    let topicCKEditorInput = $(`#cke_meeting_topic_${meetingObj.id}_${topic.id}`);
    if(topicCKEditorInput != undefined) {
      let topicCKEditorInputValue = $(`#cke_meeting_topic_${meetingObj.id}_${topic.id}` + ' iframe').contents().find('body').html();
      if (topicCKEditorInputValue == '<br>') {
        topicCKEditorInputValue= '';
      }
      $(`#meeting_topic_${meetingObj.id}_${topic.id}`).val(topicCKEditorInputValue);
    }
    const fieldObj = $(`#meeting_topic_${meetingObj.id}_${topic.id}`);
    const subActText = $.trim($(fieldObj).val());
    if (subActText == "") {
      return;
    }

    const quickAddAI = $(fieldObj).data("quickAddAI");
    if (e.ctrlKey && e.keyCode == 13) {
      if (navigator.userAgent.indexOf("Mac OS X") != -1) {
        if (navigator.userAgent.indexOf("Chrome") != -1) {
          $.trim($(fieldObj).html(`${subActText}<br /><br />`));
          WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
        } else {
          $.trim($(fieldObj).html(subActText));
          WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
        }
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $.trim($(fieldObj).html(`${subActText}<br /><br />`));
        WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
      } else {
        $.trim($(fieldObj).html(subActText));
        WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
      }
    }
    // submitted the topic if enters either "enter" / enter key in quick AI mode / (ctrl key/command key + 's' key.
    // else if (
    //   ((e.keyCode == 13 && quickAddAI == true) ||
    //     ((e.ctrlKey || e.metaKey) && e.keyCode == 83)) &&
    //   subActText != ""
    // ) {
    //   e.preventDefault();
    //   this.submitUpdatedTopic(subActText);
    // } 
    else {
      return false;
    }
    this.submitUpdatedTopic(subActText);
  }

  submitUpdatedTopic(topicText, updatedS3Data) {
    const { meetingObj, topic, actions } = this.props;
    const topicId = topic.id;
    const fname = topic.firstname;
    const lname = topic.lastname;
    const meetingId = meetingObj.id;
    const tagId = topic.tag;

    const fieldObj = $(`#meeting_topic_${meetingId}_${topicId}`);
    let quickAddAI = true; // $(fieldObj).data("quickAddAI");
    const quickAddAIParams = {};
    const meetingWsId = this.props.meetingObj.id;
    if (
      quickAddAI == true &&
      !topicText.match(/#(.*)#/) &&
      !topicText.match(/@(.*)@/) &&
      !topicText.match(/(\!)(\d)+(\?)*/g)
    ) {
      quickAddAI = false;
    }
    if (quickAddAI == true && topicText.match(/@(.*)@/) && !topicText.match('data-userid')) {
      quickAddAI = false;
    }
    if( quickAddAI == true && topicText.match(/#(.*)#/) && !topicText.match('data-quickaddtagid')) {
      quickAddAI = false;
    }
    if (quickAddAI == true) {
      const isvalid = quickAddEventHandler(fieldObj);
      if (!isvalid) {
        return;
      }
      quickAddAIParams.tagId = getWsTagId(topicText);
      if (
        quickAddAIParams.tagId == "" ||
        typeof quickAddAIParams.tagId === "undefined"
      ) {
        quickAddAIParams.tagId = meetingWsId;
      }
      quickAddAIParams.userId = getUserId(topicText);
    }

    if (updatedS3Data) {
      actions.UpdateMeetingS3Data("mtS3Data", updatedS3Data);
    }
    this.props.updateTopicTake(
      topicText,
      meetingId,
      topicId,
      tagId,
      fname,
      lname,
      this.state.type,
      null,
      quickAddAI,
      quickAddAIParams,
      this.afterUpdateTopic
    );
  }

  afterUpdateTopic(subActText, topicId) {
    this.props.disableTopicText(topicId);
  }

  selectArea(e, id) {
    e.preventDefault();

    const { meetingObj, topic } = this.props;
    const eleId = this.getEleId();
    autoResizeTextArea({ eleId: `#${eleId}` });
  }

  render() {
    const { meetingObj, topic, t } = this.props;
    const topicMiddleDetId = topic.id;
    let topicDesc = topic.description;

    const textareaId = `meeting_topic_${meetingObj.id}_${topicMiddleDetId}`;

    topicDesc = topicDesc.replaceAll('<strong style="font-weight: bold">', '<strong>')
                         .replaceAll('<strong style="font-weight:bold">', '<strong>')
      .replaceAll('<span style="font-style: italic">', '<span>')
      .replaceAll('<span style="font-style:italic">', '<span>')
    return (
      <div
        className="wb-table-col wb-table-col-title clickable wb-table-col-edit-title editTopicTextArea dispBk"
      >
        <div className="textAlignLeft" style={{ width: "100%" }}  ref={this.wrapperRef}>
          <div
            // contentEditable="true"
            data-enable-quickadd="true"
            className="meetingagendatextbox meetingEditTopicContainer"
            id={textareaId}
            placeholder={t("Type to topic")}
            onKeyDown={event => this.updateTopic(event)}
            ref="meeting_topic"
            onKeyPress={() => autoResizeTextArea({ eleId: `#${textareaId}` })}
            onClick={e => this.selectArea(e, topicMiddleDetId)}
            dangerouslySetInnerHTML={WbMarkdownHtml(topicDesc, true)}
            data-attr-topicbody="true"
          />
          <button
            onClick={e => this.saveEditedTopic(e)}
            className="btn-circle subTopicBtn"
            style={{position:'relative', marginTop: '-41px'}}
          >
            <span className="icon icon-outline-check-24px-blue"></span>
          </button>
        </div>
      </div>
    );
  }
}
export default withTranslation()(PostTopicEditText);
